// import { Button } from "antd";
import React, { useRef, useState, useEffect, useCallback } from "react";
import {
  Link,
  NavLink,
  useLocation,
  useMatch,
  useResolvedPath,
} from "react-router-dom";
import AppLogo from "../components/Logo/AppLogo";
// import LogoutConfirm from "../components/modals/LogoutConfirm";

const Header = () => {
  const [open, setOpen] = useState(false);
  // const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);  testing.......
  const navRef = useRef();
  const location = useLocation();

  function toggleMobileNav() {
    setOpen(!open);
  }

  const close = useCallback((e) => {
    if (navRef.current.contains(e.target)) {
      return;
    } else {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    setOpen(false);
    document.addEventListener("mousedown", close);
    return () => {
      document.removeEventListener("mousedown", close);
    };
  }, [location.pathname, close]);

  return (
    <nav className="app-nav w-full flex px-5 md:px-10">
      <div className=" w-full flex items-center justify-between">
        <div
          onClick={toggleMobileNav}
          className="top-0 right-0 z-50 block w-6 mr-10 cursor-pointer select-none md:hidden sm:mt-10"
        >
          <span className="block w-3/4 h-1 mt-2 duration-200 transform bg-[#47392d] rounded-full sm:mt-1"></span>
          <span className="block w-full h-1 mt-1 duration-200 transform bg-[#47392d] rounded-full"></span>
          <span className="block w-3/4 h-1 mt-1 duration-200 transform bg-[#47392d] rounded-full"></span>
        </div>
        <div>
          <Link to={"/"}>
            <AppLogo className="md:w-32 w-24" />
          </Link>
        </div>
        <ul
          ref={navRef}
          className={`top-0 left-0 z-50 md:flex flex flex-col 
        items-center justify-center md:justify-start
        md:flex-row md:w-auto w-full bg-white 
        md:mt-0 mt-14 md:py-0 py-5 md:border-0 border
        md:relative absolute shadow md:shadow-none 
        md:space-x-10
        md:bg-transparent ${!open && "hidden"}
        `}
        >
          <AppLink path={"/"}>Dashboard</AppLink>
          <AppLink className="" path={"/documents"}>
            Documents
          </AppLink>
          <AppLink className="" path={"/summary"}>
            Summary
          </AppLink>
          <AppLink className="" path={"/account"}>
            Account
          </AppLink>
        </ul>
      </div>
    </nav>
  );
};

export default Header;

const AppLink = ({ path, children, className }) => {
  let resolved = useResolvedPath(path);
  let match = useMatch({ path: resolved.pathname, end: true });

  return (
    <NavLink
      className={`app-text text-base nav-link text-center ml-0 mb-3 md:mb-0
        ${match ? "active " : ""} 
        ${className}`}
      to={path}
    >
      {children}
    </NavLink>
  );
};
